import { Api } from './axios-config';

export interface IServiceView {
  id: number;
  businessId: number;
  description: string;
  amount: number;
  serviceDuration: number;
  requiresPreApproval: boolean;
  isActive: boolean;
}

const getById = async (id: number): Promise<IServiceView> => {
  try {
    const { data } = await Api.get<IServiceView>(
      `/service/${id}`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};


const getByIds = async (ids: number[]): Promise<IServiceView[]> => {
  try {
    const { data } = await Api.post<IServiceView[]>(
      '/service/ids', ids
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByBusiness = async (businessId: number, onlyActive?: boolean): Promise<IServiceView[]> => {
  try {
    const params = onlyActive !== undefined ? `?onlyActive=${onlyActive}` : '';
    const { data } = await Api.get<IServiceView[]>(
      `/service/business/${businessId}${params}`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface ICreateService {
  businessId: number;
  description: string;
  amount: number;
  serviceDuration: number;
  requiresPreApproval?: boolean;
  isActive?: boolean;
}

const create = async (body: ICreateService): Promise<number> => {
  try {
    const { data } = await Api.post(
      '/service',
      body
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export interface IUpdateService {
  id: number;
  businessId: number;
  description: string;
  amount: number;
  serviceDuration?: number;
  requiresPreApproval?: boolean;
  isActive?: boolean;
}

const update = async (body: IUpdateService): Promise<IServiceView> => {
  try {
    const { data } = await Api.put(
      '/service',
      body
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const remove = async (id: number): Promise<void> => {
  try {
    await Api.delete(
      `/service/${id}`
    );

  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const serviceService = {
  getById,
  getByIds,
  getByBusiness,
  create,
  update,
  remove
};